<template>
  <dl class="table_box">
    <dt>社名</dt>
    <dd>株式会社フルー</dd>

    <dt>創業</dt>
    <dd>2020年7月3日</dd>

    <dt>資本金</dt>
    <dd>300万円</dd>

    <dt>所在地</dt>
    <dd>〒176-0004 東京都練馬区小竹町1－51－14</dd>

    <dt>代表取締役</dt>
    <dd>矢野 貴大（やの たかひろ）</dd>

    <dt>代表者経歴</dt>
    <dd>
      1983年生まれ、埼玉県出身<br>
      <br>
      2007年 北海道大学工学部建築学科卒業<br>
      <br>
      2009年 北海道大学大学院工学院 修士課程修了<br>
      鹿島建設株式会社入社 建築設計本部構造設計グループ配属<br>
      <br>
      2014年 同社 中部支店（名古屋）構造設計グループ配属<br>
      <br>
      2018年 同社 建築設計本部構造設計グループ配属<br>
      <br>
      2020年 鹿島建設株式会社を退職<br>
      株式会社フルーを設立<br>
      <br>
      保有資格：一級建築士、構造設計一級建築士
    </dd>

    <dt>お問い合わせ</dt>
    <dd><a target="_blank" href="https://cadflew.com/contact/" class="link_label">https://cadflew.com/contact/</a></dd>
  </dl>
</template>

<script>
  export default {
    name: "AboutTableBlock"
  }
</script>

<style lang="scss" scoped>
  dl {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    border-left: 1px solid $border_color;
    border-bottom: 1px solid $border_color;

    > dt, dd {
      margin: 0;
      border-top: 1px solid $border_color;
      border-right: 1px solid $border_color;
      padding: 1rem;

      > p {
        width: 100%;
        text-align: end;
      }
    }

    > dt {
      font-size: $big-font-size;
      font-weight: bold;
      border-right: 1px solid $border_color;
      width: 20%;
    }

    > dd {
      width: 80%;
      border-left: none;
      white-space: pre-line;
    }

    @media screen and (max-width: 767px) {
      > dt {
        width: 30%;
      }

      > dd {
        width: 70%;
      }
    }
  }
</style>